import { IGetAllPgtoContratoFinanceiroUseCase } from "../../../presentation/useCases/read/get_all_pgto_contrato_financeiro_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";
import { ModelPgtoContratoFinanceiroLista } from "../../models/pgto_contrato_financeiro_lista";

/**
 * GetAllPgtoContratoFinanceiroUseCase
 */

export class GetAllPgtoContratoFinanceiroUseCase
  extends BasePaginatedUseCase<ModelPgtoContratoFinanceiroLista>
  implements IGetAllPgtoContratoFinanceiroUseCase {
  constructor(private readonly repository: IFinanceiroRepository) {
    super();
  }

  async getAllPgtoContratoFinanceiro(
    idPgtoContratoFinanceiro: number,
    page: number,
    rowsPerPage: number): Promise<void> {
    const result = await this.repository.getAllPgtoContratoFinanceiroLista(
      idPgtoContratoFinanceiro,
      page,
      rowsPerPage
    )

    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;

  }
}
